import {
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import {
  FormGroup,
} from "@angular/forms";

@Component({
    selector: "mfh-shell-inspection-fields",
    templateUrl: "./mfh-shell-inspection-fields.component.html",
    standalone: false
})

//pass the inputs when changed to the parent component (inspection-data.component) to update the formGroup values and perform calculations for MFH mode
export class MFHInspectionFieldsComponent {

    @Input() formGroup: FormGroup;          // pass inspectionDataFormGroup
    @Input() intUnit: number;          // pass intUnit for unit system (0 = US, 1 = SI)

    @Output() tam_change = new EventEmitter<Event>();    // textBox1_DI
    @Output() tmm_change = new EventEmitter<Event>();    // textBox2_DI
    @Output() hml_change = new EventEmitter<Event>();    // textBox3_DI_sngH_f
    @Output() fcaml_change = new EventEmitter<Event>();  // textBox7_DI_sngHf

    // MFH data
    onTamChange(event: Event): void {
        this.tam_change.emit(event);
    }
    onTmmChange(event: Event): void {
        this.tmm_change.emit(event);
    }
    onHmlChange(event: Event): void {
        this.hml_change.emit(event);
    }
    onFcamlChange(event: Event): void {
        this.fcaml_change.emit(event);
    }   
}

